import { render, staticRenderFns } from "./freezer-unlock.vue?vue&type=template&id=155ec640&scoped=true&"
import script from "./freezer-unlock.vue?vue&type=script&lang=js&"
export * from "./freezer-unlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ec640",
  null
  
)

export default component.exports